/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_OpenInputs */

const en_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about seeds & growing`)
};

const th_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สอบถามเรื่องเมล็ดพันธุ์และการปลูก`)
};

const ja_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about seeds & growing`)
};

const fr_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about seeds & growing`)
};

const es_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about seeds & growing`)
};

const ru_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about seeds & growing`)
};

const zh_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about seeds & growing`)
};

const vi_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỏi về hạt giống và cách trồng`)
};

/**
* | output |
* | --- |
* | "Ask about seeds & growing" |
*
* @param {Chat_OpenInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_open = /** @type {((inputs?: Chat_OpenInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_OpenInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_open(inputs)
	if (locale === "ja") return ja_chat_open(inputs)
	if (locale === "fr") return fr_chat_open(inputs)
	if (locale === "es") return es_chat_open(inputs)
	if (locale === "ru") return ru_chat_open(inputs)
	if (locale === "zh") return zh_chat_open(inputs)
	if (locale === "vi") return vi_chat_open(inputs)
	return en_chat_open(inputs)
});